import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { has, keyBy, sortBy } from 'lodash/fp';
import parse from 'html-react-parser';
import { withTheme } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { EventTrackingMethodType } from '../../interfaces/EventType';

const ProgramsLabel = withTheme(styled(Typography)`
  font-size: 13px;
  margin-top: 15px;
  ${({ theme: { breakpoints } }) => `${breakpoints.down('sm')} {
    font-size: 11px;
    margin-top: 10px;
  }`};
  > span {
    &:not(:last-child):after {
      content: ', ';
    }
    &.selected {
      font-weight: 600;
    }
    &.ineligible {
      font-weight: 600;
      color: ${({ theme: { palette } }) => palette.error.light};
      text-decoration: line-through;
    }
  }
`);

const ReservedEventPrograms = ({ data, reservedPrograms, ...props }) => {
  const sortedPrograms = sortBy('label', data);
  const reservedProgramById = keyBy('id', reservedPrograms);
  return (
    <ProgramsLabel {...props}>
      {sortedPrograms.map(({ id, label }) => (
        <span
          key={label}
          className={has(id, reservedProgramById) ? 'selected' : 'ineligible'}
        >
          {parse(label)}
        </span>
      ))}
    </ProgramsLabel>
  );
};

export const ReservedProgramsType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })
);

ReservedEventPrograms.propTypes = {
  data: PropTypes.arrayOf(EventTrackingMethodType).isRequired,
  reservedPrograms: ReservedProgramsType.isRequired
};

export default ReservedEventPrograms;
